import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconCheck = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconCheck",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "m382-354 339-339q12-12 28-12t28 12 12 29-12 28L410-268q-12 12-28 12t-28-12L182-440q-12-12-11-28t12-29 29-12 28 12z"
  })
}));